import {
  getcustomerDetails,
  creatCustomers,
  getPaymentDestination,
  creatPaymentIntent,
  getLeanBanks,
} from "src/action";

export const customerDetails = async (clientId) => {
  const res = await getcustomerDetails({
    customerId: clientId,
    provider: "leantech",
  });
  if (res && res?.data?.data !== null) {
    return res;
  } else {
    const res1 = await creatCustomers({
      customerId: clientId,
      provider: "leantech",
    });
    if (res1.message === "Something went wrong") return res1;
  }
};

export const PaymentDestination = async () => {
  const res = await getPaymentDestination({ provider: "leantech" });
  if (res && res?.data?.data !== null) return res;
};

export const getPaymentDestinationDetails = async () => {
  const res = await getPaymentDestination({ provider: "leantech" });
  if (res && res?.data?.data !== null) return res?.data?.data;
};

export const createIntents = async (props) => {
  const { amount, customerId, paymentDestinationId, currency } = props;
  const res = await creatPaymentIntent({
    provider: "leantech",
    amount,
    currency,
    customerId,
    paymentDestinationId,
  });
  if (res.message === "Something went wrong")
    console.error("Something went wrong");
  return res;
};

export const fetchingBanks = async () => {
  let res = await getLeanBanks({ provider: "leantech" });
  if (res && res?.data !== null) return res;
  else {
    console.error("cant fetching Banks");
    return null;
  }
};
